import { useEffect, useRef } from "react";
import axios from "axios";

// Shared ViaCEP autofill. Call with the CEP string being typed and a callback
// that receives the ViaCEP payload (logradouro, bairro, localidade, uf, ibge, …).
// Silent on failure: user can keep filling by hand.
export function useViaCep(cep, onFill) {
  const last = useRef("");
  useEffect(() => {
    const c = (cep || "").toString().replace(/\D/g, "");
    if (c.length !== 8 || last.current === c) return;
    last.current = c;
    axios.get(`https://viacep.com.br/ws/${c}/json/`, { timeout: 6000, withCredentials: false })
      .then(({ data }) => { if (data && !data.erro) onFill(data); })
      .catch(() => {});
  }, [cep]); // eslint-disable-line react-hooks/exhaustive-deps
}
